import React from "react";
import { FaHandshake, FaFileAlt, FaCalculator } from "react-icons/fa";
import { PageShell, PageHeader, AppLink } from "../../Components/shared";

export default function OfferSelectionPage() {
  return (
    <PageShell>
      <div className="p-4 sm:p-6 space-y-6 overflow-y-auto flex-1">
        <PageHeader
          icon={FaHandshake}
          iconColor="amber"
          title="Teklif Oluştur"
          subtitle="Teklif tipini seçin"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto mt-8">
          {/* Sade Teklif */}
          <AppLink
            to="/Anasayfa/Teklif/Sade"
            className="group relative flex flex-col items-center gap-4 p-8 bg-white border-2 border-gray-200 rounded-2xl shadow-sm hover:shadow-lg hover:border-main transition-all duration-200 text-left"
          >
            <div className="p-4 bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl group-hover:scale-105 transition-transform">
              <FaFileAlt className="w-10 h-10 text-amber-600" />
            </div>
            <div className="text-center">
              <h3 className="text-lg font-bold text-gray-900">Sade Teklif</h3>
              <p className="text-sm text-gray-500 mt-1">
                Word benzeri editör ile hızlı teklif oluşturun
              </p>
            </div>
            <span className="inline-flex items-center gap-1 px-3 py-1 bg-sixth/10 text-sixth text-xs font-semibold rounded-full">
              Aktif
            </span>
          </AppLink>

          {/* Detayli Teklif */}
          <AppLink
            to="/Anasayfa/Teklif/Detayli"
            className="group relative flex flex-col items-center gap-4 p-8 bg-white border-2 border-gray-200 rounded-2xl shadow-sm hover:shadow-lg hover:border-main transition-all duration-200 text-left"
          >
            <div className="p-4 bg-gradient-to-br from-sky-50 to-blue-50 rounded-xl group-hover:scale-105 transition-transform">
              <FaCalculator className="w-10 h-10 text-blue-600" />
            </div>
            <div className="text-center">
              <h3 className="text-lg font-bold text-gray-900">
                Detaylı Teklif
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                Kapsamlı hesaplama ve analiz ile teklif oluşturun
              </p>
            </div>
            <span className="inline-flex items-center gap-1 px-3 py-1 bg-sixth/10 text-sixth text-xs font-semibold rounded-full">
              Aktif
            </span>
          </AppLink>
        </div>
      </div>
    </PageShell>
  );
}
